import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { BUTTON_UPLOAD_POSITION, FILE_TYPE, PAGINATION_DEFAULT, UPLOAD_TYPE } from "src/constant/common";
import { FORM_NAME } from "src/pages/ProjectInstance/detail";
import classNames from "classnames";
import FormUpload from "src/components/Common/Form/FormUpload";
import TableCommon from "src/components/Common/Table";
import { columns } from "./columns";
import useUrlState from "@ahooksjs/use-url-state";

const Files = ({
  errors,
  register,
  navigationPrompt,
  isAllowEdit,
  setValue,
  watch,
  clearErrors,
  setIsUpload,
  fileHistories,
  isFetchingFileHistories,
  instanceData,
}) => {
  const { t } = useTranslation("project-instance");

  const ensureArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  const watchMissionDatabase = ensureArray(watch(FORM_NAME.FILES.MDB));
  const watchDashboardOpi = ensureArray(watch(FORM_NAME.FILES.DASHBOARD_OPI));

  const [params, setParams] = useUrlState(
    {},
    {
      navigateMode: "replace",
      stringifyOptions: {
        skipNull: true,
        skipEmptyString: true,
      },
    }
  );

  const handleUpdateAttachmentsFile = (file, fieldName) => {
    setValue(fieldName, file, { shouldDirty: true });
    if (watch(fieldName)) {
      clearErrors(fieldName);
    }
  };

  const onChangePage = (value) => {
    setParams({
      ...params,
      filesHistoryPage: value,
    });
  };

  const getCurrentPage = () => {
    return (params?.filesHistoryPage || PAGINATION_DEFAULT.page) - 1;
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="2" className="mt-0 fw-bold">
        {t("detail.files_section")}
      </AccordionHeader>
      <AccordionBody accordionId="2">
        <div
          className={classNames("row mb-1 ms-1", {
            "align-items-start": isAllowEdit,
            "align-item-center": !isAllowEdit,
          })}
        >
          <div className="col-md-3 p-y-8">
            <Label className="position-relative mb-0">{`${t(`detail.${FORM_NAME.FILES.DASHBOARD_OPI}`)}: `}</Label>
          </div>
          <div className="col-md-9 p-b-8">
            <FormUpload
              register={register}
              errors={errors}
              files={watchDashboardOpi}
              name={FORM_NAME.FILES.DASHBOARD_OPI}
              updateAt={instanceData?.[FORM_NAME.FILES.OPI_UPDATE]}
              fileTypeAllow={[FILE_TYPE.OPI]}
              uploadType={UPLOAD_TYPE.OPI}
              fileTypeValidateMsg="validate_attachments"
              handleUpdateAttachments={(file) => handleUpdateAttachmentsFile(file, FORM_NAME.FILES.DASHBOARD_OPI)}
              onUpload={setIsUpload}
              isMultiple={true}
              isReplaceFileWhenUpload
              isShowButtonUpload={isAllowEdit}
              isShowFileIcon={false}
              isShowButtonDelete={false}
              buttonUploadPosition={BUTTON_UPLOAD_POSITION.END}
              classGroup="file-upload mb-0"
            />
          </div>
        </div>
        <div
          className={classNames("row mb-1 ms-1", {
            "align-items-start": isAllowEdit,
            "align-item-center": !isAllowEdit,
          })}
        >
          <div className="col-md-3 p-y-8">
            <Label className="position-relative mb-0">{`${t(`detail.${FORM_NAME.FILES.MDB}`)}: `}</Label>
          </div>
          <div className="col-md-9 p-b-8">
            <FormUpload
              register={register}
              errors={errors}
              files={watchMissionDatabase}
              name={FORM_NAME.FILES.MDB}
              updateAt={instanceData?.[FORM_NAME.FILES.MDB_UPDATE]}
              fileTypeAllow={[FILE_TYPE.XLS]}
              uploadType={UPLOAD_TYPE.MDB}
              fileTypeValidateMsg="validate_attachments"
              handleUpdateAttachments={(file) => handleUpdateAttachmentsFile(file, FORM_NAME.FILES.MDB)}
              onUpload={setIsUpload}
              isMultiple={true}
              isReplaceFileWhenUpload
              isShowButtonUpload={isAllowEdit}
              isShowFileIcon={false}
              isShowButtonDelete={false}
              buttonUploadPosition={BUTTON_UPLOAD_POSITION.END}
              classGroup="file-upload mb-0"
            />
          </div>
        </div>
        <span className="fw-bold mb-1 d-block">{t("detail.history_table.title")}</span>
        <TableCommon
          loading={isFetchingFileHistories}
          columns={columns({ t })}
          data={fileHistories?.items || []}
          onChangePage={onChangePage}
          tableFixed
          tableClassName="table table-custom table-collapse table-fixed"
          customClassName="overflow-auto simulation-table"
          pageCurrent={getCurrentPage()}
          pageCount={fileHistories?.pagination?.total_page}
          totalItem={fileHistories?.pagination?.total}
          pageSize={PAGINATION_DEFAULT.smallPageSize}
          classTableHead="table-header-custom"
          classTableBody="table-body-custom"
        />
      </AccordionBody>
    </AccordionItem>
  );
};

export default Files;
